
// Export a function that creates the environment dynamically
export function createAuthEnvironment(dynamicConfig?: any) {
  const configToUse = dynamicConfig || {
    domain: '',
    clientId: '',
    authorizationParams: { audience: '' },
    apiUri: '',
    errorPath: '/error'
  };
  const { domain, clientId, authorizationParams: { audience }, apiUri, errorPath } = configToUse;
  
  return {
    auth: {
      domain,
      clientId,
      authorizationParams: {
        ...(audience ? { audience } : null),
        redirect_uri: window.location.origin,
      },
      errorPath,
    },
    httpInterceptor: {
      allowedList: [`${apiUri}/*`],
    },
  };
}

// Export static environment for immediate use (will be replaced by dynamic one)
export const environment = createAuthEnvironment();
